'use client';

import dynamic from 'next/dynamic';

const Player = dynamic(
  () => import('@lottiefiles/react-lottie-player').then((module) => module.Player),
  { ssr: false }
);

type LoadingGifProps = {
  label?: string;
  size?: number;
  className?: string;
  textClassName?: string;
  orientation?: 'row' | 'column';
  priority?: boolean;
};

export default function LoadingGif({
  label,
  size = 48,
  className,
  textClassName,
  orientation = 'row',
  priority = false,
}: LoadingGifProps) {
  return (
    <div
      className={[
        'flex items-center justify-center',
        orientation === 'column' ? 'flex-col gap-3' : 'gap-3',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      <Player
        autoplay
        loop
        src="/assets/images/loading.json"
        style={{ width: size, height: size }}
        className="select-none pointer-events-none"
      />
      {label ? (
        <span className={['text-sm text-white', textClassName].filter(Boolean).join(' ')}>
          {label}
        </span>
      ) : null}
    </div>
  );
}